<template>
  <div class="liu">
    <mt-button @click="onClick">点这里</mt-button>
  </div>
</template>

<script>
import { RedirectPay } from "@/api/test";

export default {
  name: "Test",
  data() {
    return {};
  },

  mounted() {},

  methods: {
    onClick() {
      RedirectPay(`a=1&b=2&c=3`).then((res) => console.log(res));
    },
  },
};
</script>
